import { useMutation, useQuery } from 'react-query';
import { authDao } from 'shared/dao/authDao';
import {
  IRefreshTokenRequestPayload,
  IUserChangePasswordRequestPayload,
  IUserChangePasswordResponsePayload,
  IUserCompleteProfilePayload,
  IUserCompleteProfileResponsePayload,
  IUserResponsePayload,
} from 'shared/interfaces/IUser';
import { IAxiosErrorResponse } from 'shared/interfaces/utils/IAxios';
import { ls } from 'shared/utils/ls';

const { setLS } = ls();

const {
  getUserProfile: getUserProfileDao,
  generateRefreshToken: generateRefreshTokenDao,
  resendConfirmation: resendConfirmationDao,
  setCompleteProfile: setCompleteProfileDao,
  changePassword: changePasswordDao,
  loginWithGoogle: loginWithGoogleDao,
  loginWithFacebook: loginWithFacebookDao,
  resetPasswordTokenChecker: resetPasswordTokenCheckerDao,
  generateToken: generateTokenDao,
} = authDao();
export const authService = () => {
  const getUserProfile = () => {
    return useQuery<IUserResponsePayload, IAxiosErrorResponse>(['user'], () => getUserProfileDao());
  };

  const generateRefreshToken = async (payload: IRefreshTokenRequestPayload) => {
    try {
      const response = await generateRefreshTokenDao(payload);
      setLS('auth_token', response.token);
      setLS('refersh_token', response.refresh_token);
      return response;
    } catch (err: any) {
      throw new Error(err);
    }
  };

  const resendConfirmation = () => {
    return useMutation(() => resendConfirmationDao());
  };

  const changePassword = () => {
    return useMutation<
      IUserChangePasswordResponsePayload,
      IAxiosErrorResponse,
      { payload: IUserChangePasswordRequestPayload }
    >(({ payload }) => changePasswordDao(payload));
  };

  const loginWithGoogle = () => {
    return useMutation((token: string) => loginWithGoogleDao(token));
  };

  const loginWithFacebook = () => {
    return useMutation((token: string) => loginWithFacebookDao(token));
  };

  const setCompleteProfile = () => {
    return useMutation<IUserCompleteProfileResponsePayload, Error, IUserCompleteProfilePayload>(
      (payload: IUserCompleteProfilePayload) => setCompleteProfileDao(payload),
    );
  };

  const resetPasswordTokenChecker = () => {
    return useMutation<boolean, IAxiosErrorResponse, string>((token) => resetPasswordTokenCheckerDao(token));
  };

  const generateToken = () => {
    return useMutation((user_id: string) => generateTokenDao(user_id));
  };

  return {
    generateToken,
    setCompleteProfile,
    resendConfirmation,
    loginWithFacebook,
    loginWithGoogle,
    generateRefreshToken,
    getUserProfile,
    changePassword,
    resetPasswordTokenChecker,
  };
};
